


import React, { useEffect, useState } from "react";

const LocationPicker = ({ venues }) => {
  // console.log("Venues in LocationPicker:", venues);
  const [mapUrls, setMapUrls] = useState([]);


  useEffect(() => {
    const urls = (venues || [])
      .filter(v => v.venueName && v.city && v.state)
      .map(v => {
        const address = `${v.venueName}, ${v.city}, ${v.state}`;
        const encodedAddress = encodeURIComponent(address);
        return `https://www.google.com/maps/embed/v1/place?key=AIzaSyB-gVctQM60ryDKyVillfLrYrG0DXIvQuA&q=${encodedAddress}`;
      });
    setMapUrls(urls);
  }, [venues]);

  return (
    <>
      {mapUrls.map((url, index) => (
        <div key={index} style={{ marginBottom: 20 }}>
          <div style={{ fontWeight: 500, marginBottom: 4 }}>
            {/* {venues[index].venueName}, {venues[index].city}, {venues[index].state} */}
          </div>
          <iframe
            width="80%"
            height="200"
            frameBorder="0"
            style={{ border: 0, borderRadius: 8 }}
            src={url}
            allowFullScreen
          ></iframe>
        </div>
      ))}

    </>
  );
};

export default LocationPicker;

